import { IReportTuyenSinhRequest } from "../../../model/request/report/IReportTuyenSinhRequest";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IReportTuyenSinhRespone } from "../../../model/respone/report/IReportTuyenSinhRespone";
import { IReportTuyenSinhActionTypes } from "../../action-types/report/IReportTuyenSinhActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IReportTuyenSinhReducer } from "../../reducer-model/report/IReportTuyenSinhReducer";

const iniState: IReportTuyenSinhReducer = {
  status: eReducerStatusBase.is_not_initialization,
  filerModeReport: "all-co-cong-no",
  isShowFilter: false,
  reports: {} as IPagingResult<IReportTuyenSinhRespone[]>,
  request: {
    nam_tuyen_sinh: 0,
    id_hes: [],
    dot_tuyen_sinhs: [],
    id_thu_chis: [],
    is_co_cong_no: false,
    search_key: "",
    trang_thai_nop_tien: "all",
    mau_so: "",
    page_index: 0,
    page_size: 100,
    id_hinh_thuc_thus: [],
  } as IReportTuyenSinhRequest,
};
export const reportTuyenSinhReducer = (
  state: IReportTuyenSinhReducer = iniState,
  action: IReportTuyenSinhActionTypes,
): IReportTuyenSinhReducer => {
  switch (action.type) {
    case "REPORT_TUYEN_SINH_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "REPORT_TUYEN_SINH_LOAD_SUCCESS":
      return {
        ...state,
        reports: action.payload,
        status: eReducerStatusBase.is_completed,
      };
    case "REPORT_TUYEN_SINH_LOAD_ERROR":
      return {
        ...state,
        reports: {} as IPagingResult<IReportTuyenSinhRespone[]>,
        status: eReducerStatusBase.is_completed,
      };
    case "REPORT_TUYEN_SINH_CHANGE_REPORT_FILTER":
      return {
        ...state,
        filerModeReport: action.payload,
        status:
          state.request.is_co_cong_no && action.payload === "all"
            ? eReducerStatusBase.is_need_reload
            : state.status,
        request: {
          ...state.request,
          is_co_cong_no: action.payload !== "all",
        },
      };
    case "REPORT_TUYEN_SINH_CHANGE_REQUEST": {
      // Chỉ paging mới auto-reload. Filter/search yêu cầu "Làm mới".
      const reloadKeys = ["page_index", "page_size"];
      const keys = Object.keys(action.payload);
      const isReload =
        keys.length > 0 && keys.every((k) => reloadKeys.includes(k));
      return {
        ...state,
        ...(isReload && {
          reports: {} as IPagingResult<IReportTuyenSinhRespone[]>,
          status: eReducerStatusBase.is_need_reload,
        }),
        request: {
          ...state.request,
          ...action.payload,
        },
      };
    }
    case "REPORT_TUYEN_SINH_SHOW_MODAL_LIST_BIEN_LAI":
      return {
        ...state,
        isShowListBienLai: true,
        idThiSinh: action.payload,
      };
    case "REPORT_TUYEN_SINH_CLOSE_MODAL_LIST_BIEN_LAI":
      return {
        ...state,
        isShowListBienLai: false,
      };
    case "REPORT_TUYEN_SINH_SHOW_HIDE_FILTER":
      return {
        ...state,
        isShowFilter: action.payload,
      };
    default:
      return state;
  }
};
